// extracted by mini-css-extract-plugin
export var truncate = "utility-module--truncate--6cc20";